// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2Ar9U","form":"styles_form__1NMQz"};